export const environment = {
  production: false,
  apiUrl: 'https://api.dev.beetrics.com/v1',
  // Simula el backend de integraciones (Skello) mientras no está disponible.
  useMockIntegrations: false,
};
